import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {

    // eslint-disable-next-line
    create({ commit }, data) {
      return new Promise(resolve => {
        api.submitTransaction(data).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('depositManual', store);
